import store from './store'
export default store


// WEBPACK FOOTER //
// ./src/store/index.js